<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      breadcrumb: {
        title: 'Users',
        name: 'Users',
        route: {
          name: 'manage-users'
        }
      }
    }
  }
}
</script>
